import React from "react";

const LogoCloud = () => {
  const logos = [
    "VILLA AZURE",
    "OCEANFRONT CASA",
    "MOUNTAIN RETREAT",
    "THE SANCTUARY",
    "SUNSET VILLA",
  ];

  return (
    <div className="mt-16 py-8 border-y border-black/5">
      <p className="text-center text-[10px] font-mono tracking-[0.25em] text-slate-400 uppercase mb-8 font-bold">
        Trusted by 500+ Luxury Villas & Estates
      </p>
      <div className="flex flex-wrap justify-center items-center gap-x-6 sm:gap-x-12 gap-y-4 sm:gap-y-6 px-4">
        {logos.map((logo, index) => (
          <span 
            key={index} 
            className="text-base md:text-lg font-bold tracking-tight text-slate-300 font-['Lexend'] hover:text-slate-500 transition-colors duration-300"
          >
            {logo}
          </span>
        ))}
      </div>
    </div>
  );
};

export default LogoCloud;
